<div class="container mx-auto">
  <!-- Header Section -->
  <div
    class="flex flex-wrap items-center justify-between mb-6 pb-4 border-b border-base-300"
  >
    <div class="flex-1">
      <h2 class="text-2xl font-bold text-base-content flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
          />
        </svg>
        My Subscriptions
      </h2>
      <p class="text-sm text-base-content/60 mt-1">
        View and manage your active subscriptions
      </p>
    </div>
  </div>

  <div class="flex flex-wrap">
    <div class="w-full">
      <div
        class="daisy-card bg-base-100 border border-base-300 shadow-sm overflow-hidden"
      >
        <div class="daisy-card-body p-0">
          <div class="overflow-x-auto">
            <table class="daisy-table">
              <thead class="bg-base-200">
                <tr>
                  <th class="font-semibold">Class Name</th>
                  <th class="font-semibold">Status</th>
                  <th class="font-semibold">Renews On</th>
                  <th class="font-semibold">Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (subscription of subscriptions; track subscription) {
                <tr class="hover:bg-base-200 transition-colors">
                  <td class="max-w-[300px]">
                    <div class="flex items-center gap-3">
                      <div class="daisy-avatar daisy-placeholder">
                        <div
                          class="bg-primary/10 text-primary rounded-lg w-10 h-10"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                            />
                          </svg>
                        </div>
                      </div>
                      <div>
                        <div
                          class="font-medium truncate"
                          title="{{ subscription.liveClass.title }}"
                        >
                          {{ subscription.liveClass.title }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="flex flex-col gap-2">
                      <span
                        class="daisy-badge"
                        [class.daisy-badge-success]="
                          subscription.status === 'ACTIVE'
                        "
                        [class.daisy-badge-warning]="
                          subscription.status === 'PENDING'
                        "
                        [class.daisy-badge-error]="
                          subscription.status === 'CANCELLED' ||
                          subscription.status === 'EXPIRED'
                        "
                        title="{{ subscription.status }}"
                      >
                        {{ subscription.status }}
                      </span>
                      @if (subscription.isCancelRequested) {
                      <span
                        class="daisy-badge daisy-badge-warning daisy-badge-sm"
                        title="Active until {{
                          subscription.nextPaymentDeadline | date: 'MMM d, y'
                        }}"
                      >
                        Expires
                        {{
                          subscription.nextPaymentDeadline | date: 'MMM d, y'
                        }}
                      </span>
                      }
                    </div>
                  </td>
                  <td class="min-w-[150px]">
                    <div class="flex items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-base-content/60"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      <span
                        title="{{ subscription.nextPaymentDeadline | date }}"
                      >
                        {{
                          subscription.nextPaymentDeadline | date: 'MMM d, y'
                        }}
                      </span>
                    </div>
                  </td>
                  <td>
                    @if (!subscription.isCancelRequested) {
                    <black-confirm-dialog
                      confirmBtnLevel="warning"
                      bodyText="Are you sure you want to cancel this subscription? This action is irreversible."
                      (confirm)="cancelSubscription(subscription._id)"
                    >
                      <button
                        *blackConfirmDialogTrigger="let toggle = toggle"
                        (click)="toggle()"
                        class="daisy-btn daisy-btn-sm daisy-btn-warning gap-1 action-btn-mobile"
                        [disabled]="isCancelButtonDisabled(subscription)"
                        title="Cancel Subscription"
                        aria-label="Cancel subscription for {{
                          subscription.liveClass.title
                        }}"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 flex-shrink-0"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                        <span class="action-btn-text">Cancel</span>
                      </button>
                    </black-confirm-dialog>
                    } @if(subscription.isCancelRequested && subscription.status
                    === 'ACTIVE'){
                    <button
                      (click)="removeCancelRequest(subscription._id)"
                      class="daisy-btn daisy-btn-sm daisy-btn-ghost gap-1 action-btn-mobile"
                      title="Revert Cancel Request"
                      aria-label="Revert cancellation request for {{
                        subscription.liveClass.title
                      }}"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 flex-shrink-0"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                        />
                      </svg>
                      <span class="action-btn-text">Revert</span>
                    </button>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
